import Grid from '@mui/material/Grid';
import MouthTeethText from './MouthTeethText';
import MicroButtonGroup from './TeethAux/MicroButtonGroup';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import GetTeeth from './Profiling/GetTeeth';



export default function MouthSectionTeeth() {

    
    return (

     <SectionStructure
        
        sectiontext=    { <MouthTeethText /> }
        sectiondiagroup=    { <MicroButtonGroup />} 

        sectioncards=  {
        
            <Grid container spacing={0}>
                    <Grid size={{xs:12, xl:12}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start'}}> <GetTeeth /> </Grid>
                     <Grid size={{xs:12, xl:6}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start'}}>   </Grid>
                </Grid>        
        }

    />

    )
}